export const Coupon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.16667 3.5C1.16667 2.85567 1.689 2.33333 2.33333 2.33333H11.6667C12.311 2.33333 12.8333 2.85567 12.8333 3.5V5.25C12.189 5.25 11.6667 5.77233 11.6667 6.41667V7.58333C11.6667 8.22767 12.189 8.75 12.8333 8.75V10.5C12.8333 11.1443 12.311 11.6667 11.6667 11.6667H2.33333C1.689 11.6667 1.16667 11.1443 1.16667 10.5V8.75C1.811 8.75 2.33333 8.22767 2.33333 7.58333V6.41667C2.33333 5.77233 1.811 5.25 1.16667 5.25V3.5Z"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M5.25 8.75L8.75 5.25M5.54167 5.54167H5.5475M8.45833 8.45833H8.46417"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);
